module.exports = __webpack_public_path__ + "static/media/quiz.98a1dc11.svg";